<template>
  <div>
    <b-button
      v-if="!float"
      variant="link"
      class="py-0 d-print-none"
      v-b-modal.help-search
    >
      <i class="fa fa-fw fa-search"></i>
    </b-button>
    <b-button
      v-if="float"
      id="help-search-button"
      variant="outline-info"
      class="shadow d-none d-sm-inline-block d-print-none"
      v-b-modal.help-search
    >
      <i class="fa fa-fw fa-info-circle"></i>
      {{ trans('help') }}
    </b-button>
    <b-modal
      id="help-search"
      :title="trans('search_docs')"
      hide-footer
      @show="onShow"
    >
      <b-form-group>
        <b-form-input
          type="search"
          v-model="query"
          :placeholder="trans('search_docs_keywords')"
          @search="onSearch"
          @blur="onSearch"
        />
      </b-form-group>
      <p v-if="!busy && !(query || '').trim() && !!context && !!items && items.length > 0" class="text-muted">
        {{ trans('help_for_this_page') }}
      </p>
      <p v-if="!busy && !!error" class="text-danger">
        {{ error }}
      </p>
      <p v-if="busy" class="text-muted">
        <i class="fa fa-fw fa-circle-noth fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-if="!busy && items && items.length == 0" class="text-muted">
        {{ trans('none') }}
      </p>
      <b-list-group>
        <b-list-group-item
          v-for="(item, index) in items || []"
          :key="index"
          :href="item.href"
          :target="target"
        >
          <h6 v-if="item.show_h1" class="mt-2">
            {{ item.h1 }}
          </h6>
          <div v-if="item.h2">
            {{ item.h2 }}
          </div>
        </b-list-group-item>
      </b-list-group>
      <p class="contact-us">
        <em class="text-muted">
          {{ trans('not_finding_help') }}
          <a :href="contactUrl" target="_blank">{{ trans('contact_us') }}</a>.
        </em>
      </p>
    </b-modal>
  </div>
</template>

<style>
  #help-search .modal-body {
    padding-bottom: 60px;
  }
  #help-search .modal-body input[type=search] {
    display: block;
    max-width: 100%;
  }
  #help-search .modal-body .contact-us {
    position: absolute;
    bottom: 0;
    right: 20px;
  }
  #help-search-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1;
  }
  #help-search-button:not(:hover) {
    background-color: #fff;
  }
</style>

<script>
  export default {
    props: {
      organizationName: String,
      float: {
        type: Boolean,
        default: false,
      },
      target: {
        type: String,
        default: null,
      },
      search: String,
      context: String,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        query: this.search || null,
        lastQ: null,
        items: null,
      }
    },
    computed: {
      contactUrl() {
        let url = `${window.lang == 'fr' ? '/fr' : ''}/contact`
        if (this.organizationName) url += `?company=${encodeURIComponent(this.organizationName)}`
        return url
      },
      q() {
        let q = (this.query || '').trim()
        if (!q) q = (this.context || '').trim()
          return q
      },
      searchUrl() {
        return `${window.lang == 'fr' ? '/fr' : ''}/help/search?q=${encodeURIComponent(this.q)}`
      },
    },
    methods: {
      onShow() {
        this.busy = false
        this.error = null
        this.onSearch()
      },
      onSearch() {
        if (!this.q) {
          this.items = null
          this.lastQ = this.q
          return
        }
        if (this.q == this.lastQ) return
        this.lastQ = this.q

        this.busy = true
        this.error = null
        axios.get(this.searchUrl)
        .then(response => {
          this.busy = false
          let h1 = null
          this.items = _.map(response.data, item => {
            item.show_h1 = !item.h2 || h1 != item.h1
            h1 = item.h1
            return item
          })
        })
        .catch(error => {
          this.busy = false
          this.items = null
          this.searchAgain = false
          this.error = _.errorFromAjax(error)
        })
      }
    },
    mounted() {
      window.searchHelpDocs = this
    },
  }
</script>